/** Reveal-on-scroll hook — single IntersectionObserver per page, staggered via data-delay. */
import { useEffect } from "react";

let observer = null;

function getObserver() {
  if (observer) return observer;
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          en.target.classList.add("in");
          observer.unobserve(en.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: "0px 0px -6% 0px" }
  );
  return observer;
}

export function useRevealOnScroll(rootRef) {
  useEffect(() => {
    const root = rootRef?.current || document;
    const io = getObserver();
    const nodes = root.querySelectorAll(".reveal:not(.in)");
    nodes.forEach((el) => io.observe(el));
    return () => nodes.forEach((el) => io.unobserve(el));
  });
}
